import Constants from "../utils/constants";
import { API } from "../apis/APIsConfig";

export function getDistribucionBalance() {
  return API.get(Constants.APIURLS.DISTRIBUCIONBALANCE);
}

export function getInversionFondos() {
  return API.get(Constants.APIURLS.INVERSIONFONDOS);
}
